module.exports = __webpack_public_path__ + "./images/cb45ea28bb989fddf2f95a64943c23b7.webp";